import { ComponentFactoryResolver, Injectable, NgModuleRef, Type, inject } from '@angular/core';

import { OnAppInitHandler } from '@casinocore/platform';
import { InstagramSourceComponent } from '@casinocore/platform/gaming-stories';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class GamingStoriesLoaderService {
    ngModuleRef: NgModuleRef<any>;
    componentFactoryResolver: ComponentFactoryResolver;
    gamingStoriesModuleLoadedSubject = new BehaviorSubject<boolean>(false);
    gamingStoriesModuleLoadedObservable: Observable<boolean> = this.gamingStoriesModuleLoadedSubject.asObservable();
    gamingStoriesModuleLoaded: boolean;

    private onAppInitHandler = inject(OnAppInitHandler);

    loadGamingStoriesModule(): void {
        this.lazyloader();
    }

    getLazyComponentFactory(componentName: string): Type<any> {
        return componentsMap[componentName];
    }

    isModuleLoaded() {
        return this.gamingStoriesModuleLoaded;
    }

    lazyloader() {
        this.onAppInitHandler.execute();
        this.gamingStoriesModuleLoaded = true;
        this.gamingStoriesModuleLoadedSubject.next(true);
    }
}

export const componentsMap: Record<string, Type<any>> = {
    InstagramSourceComponent: InstagramSourceComponent,
};
